<template>
  <div id="app">
    <v-app id="inspire" style="overflow: hidden;"><!-- v-scroll="onScroll" -->
      <v-snackbar top v-model="snackbar" :color="color">
        <template v-if="isHtml"><div v-html="text"></div> </template>
        <template v-else>
          {{ isException ? text : $t(text) }}
        </template>
        <!-- 4975: optional action, used by the project-chat notifier so tapping
             a new-message toast opens that conversation — the web app's toasts
             are clickable the same way. Emitters that pass no `route` (the other
             ~240 call sites) render exactly as before. -->
        <template v-if="snackbarRoute" v-slot:action="{ attrs }">
          <v-btn text small v-bind="attrs" @click="goToSnackbarRoute">
            {{ $t('message.projects.chatOpen') }}
          </v-btn>
        </template>
      </v-snackbar>
      <v-main :style="$route.path === '/profile' ? 'padding: 43px 0px 0px' : ''">
         <v-container fluid class="container--app py-0" :class="$route.path === '/dashboard' ? 'px-0' : 'px-0'">
          <!-- Header Component -->
          <header-logo v-if="isAuthenticated" />
          <router-view :class="timerData.isTimeRunning ? 'mb-8' : ''" :test="test" :shiftTime="shiftTime"></router-view>
         <!--  <v-fab-transition>
            <v-btn fab bottom right color="primary" id="scroll__top" fixed v-if="showScrollToTop" @click="scrollToTop">
              <v-icon dark>mdi-chevron-up</v-icon>
            </v-btn>
          </v-fab-transition> -->
         </v-container>
      </v-main>
      <layout v-if="isAuthenticated"></layout>
      <!--Common draft dialog-->
      <div v-if="showFormDialog" class="notes-div" style="top:30%!important">
        <!--  -->
      </div>
      <!-- New content avaliable via service worker -->
      <v-fade-transition>
        <v-alert prominent v-if="getNewContentAvailable" transition="scale-transition" type="info" class="pa-2" style="position: fixed;bottom:-10px;z-index: 100;">
          <v-row align="center">
            <v-col>{{ $t('message.common.newUpdate') }}</v-col>
            <v-col class="shrink">
              <v-btn outlined @click="loadUpdateContent">{{ $t('message.common.refresh') }}</v-btn>
            </v-col>
          </v-row>
        </v-alert>
      </v-fade-transition>
      <!-- Show install popup on iOS devices -->
      <v-dialog v-model="showInstalliOS" max-width="400px" persistent class="mt-0">
        <v-card>
          <v-card-title>
            <v-flex xs11>
              <h3>Install</h3>
            </v-flex>
            <v-flex xs1 class="text-xs-right">
              <v-icon @click="showInstalliOS = false">mdi-close</v-icon>
            </v-flex>
          </v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pa-5">
            <v-layout row wrap>
              <v-flex xs12>
                {{$t('message.common.install')}}
              </v-flex>
            </v-layout>
            <v-divider class="mt-3"></v-divider>
            <v-layout>
              <v-flex xs12 class="mt-2 text-xs-center">
                <b>{{$t('message.common.justTab')}} <v-icon color="#59a7ff">mdi-open-in-app</v-icon> {{$t('message.common.addToHome')}}</b>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
      </v-dialog>
      <!-- Shift end popup -->
      <!-- <v-dialog persistent v-model="shiftEndDialog" width="500">
        <v-card>
          <v-card-title>{{ $t('message.common.confirmAddHour') }}</v-card-title>
          <v-divider></v-divider>
          <v-card-text class="pt-4 font-weight-bold text-h6">
            {{ $t('message.common.doYouWantContinue') }}
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="success" @click="continueExceed()">{{ $t('message.common.yes') }}</v-btn>
            <v-btn class="error" @click="shiftStop()">{{ $t('message.common.no') }}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog> -->
    </v-app>
  </div>
</template>

<script>
import Layout from './components/Layout'
// 4975: app-wide project-chat notifications (websocket + polled fallback).
import projectChatNotifier from './mixins/projectChatNotifier'
import { applyTheme, setDark } from '@/utils/theme'
import { fetchLayout } from '@/utils/dashboardLayout'
import { api, hostAppApi } from './plugins/axios_settings'
import { mapGetters } from 'vuex'
import goTo from 'vuetify/lib/services/goto'
import moment from 'moment'
import VueCookie from 'vue-cookie'
import VueSession from 'vue-session'
import Vue from 'vue'

Vue.use(VueSession)
export default {
  mixins: [projectChatNotifier],
  data () {
    return {
      showScrollToTop: false,
      text: '',
      snackbar: false,
      isException: false,
      color: '',
      links: [],
      formObj: {},
      formReferences: {},
      showFormDialog: false,
      discardDraftDialog: false,
      selectedDraftIndex: '',
      fromApp: true,
      showInstalliOS: false,
      notificationTitle: '',
      notificationImage: '',
      isHtml: true,
      // 4975: when set, the snackbar grows an "Open" action that navigates here.
      snackbarRoute: null,
      // shiftEndDialog: false,
      shifts: [],
      time: '00:00:00',
      test: false,
      shiftTime: null
    }
  },
  session: {
    keepAlive: true, // Extend session on user activity
    persist: true// Store session data in cookies or local storage
  },
  components: {
    Layout,
    'header-logo': () => import('./components/HeaderLogo')
  },
  computed: {
    ...mapGetters(['isAuthenticated', 'getNewContentAvailable', 'timerData', 'getuserDetails', 'getHostRefApi', 'userId', 'getTimerObj'])
  },
  created () {
    // apply the cached light/dark theme app-wide before first paint (no flicker)
    applyTheme(this.$vuetify)
    // then refresh the config from the server so the theme follows the user
    // across devices; re-apply if it changed
    // only pull the per-user config when there is a real authenticated host
    // user; on the login screen userId resolves to 0, so guarding on the token
    // alone (which can linger as a stale cookie) would fire an unauthenticated
    // request to pwa-dashboard-config and surface a "Something went wrong" error
    if (VueCookie.get(process.env.VUE_APP_TOKEN) && this.userId) {
      fetchLayout().then(saved => setDark(this.$vuetify, saved.theme === 'dark'))
    }
    // any component can request a global theme flip via this event
    this.$root.$on('appTheme', dark => setDark(this.$vuetify, dark))
    if (!this.$cookie.get('WelditPwa_host-ref')) {
      this.$store.dispatch('logout')
      this.$router.push('/login').catch(() => {})
    }
    this.loadFeaturesAndSetPermissions()
  },
  mounted () {
    this.$session.set('lastActivity', Date.now())
    document.addEventListener('mousemove', this.handleUserActivity)
    document.addEventListener('keydown', this.handleUserActivity)
    this.$root.$on('timer', data => {
      this.time = data
      this.shiftCalculations()
    })
    if (VueCookie.get(process.env.VUE_APP_TOKEN)) {
      this.getShifts()
    }
    /* Set notification title based on the host */
    // const host = this.$store.state.common.host
    switch (process.env.VUE_APP_HOST_INCLUDES) {
      case 'axentiv':
        this.notificationTitle = 'AXENTIV'
        this.notificationImage = 'axentiv'
        break
      case 'weldit':
        this.notificationTitle = 'WELD IT'
        this.notificationImage = 'weldit'
        break
      case 'novap':
        this.notificationTitle = 'NOVAP'
        this.notificationImage = 'novap'
        break
      default:
        break
    }
    /* if (host.includes(process.env.VUE_APP_HOST_INCLUDES)) {
      this.notificationTitle = 'AXENTIV'
      this.notificationImage = 'axentiv'
    } else {
      this.notificationTitle = 'WELD IT'
      this.notificationImage = 'weldit'
    } */
    if (this.$cookie.get(process.env.VUE_APP_TOKEN)) {
      // Background start-up calls: a failure (often "Request aborted" when the
      // phone backgrounds the app or the page changes mid-request) is already
      // logged by the global API error handler. Without a .catch it became an
      // unhandled promise rejection — reported to Sentry as an error.
      this.$store.dispatch('getGeneralSettings').catch(() => {})
      // get tasks count
      this.getTasksCount()
    }
    this.$root.$on('snackbar', data => {
      this.snackbar = data.snackbar
      this.color = data.color
      this.text = data.text
      this.isException = data.isException
      this.isHtml = data.isHtml || false
      // 4975: optional deep link. Always reassigned (not just when present) so a
      // plain toast after a chat toast does not inherit the previous action.
      this.snackbarRoute = data.route || null
    })
    const showniOSBanner = window.localStorage.getItem('TimerPwa_ShownInstallBanner') || false
    if (this.isIos() && !this.isInStandaloneModeIos() && !showniOSBanner) {
      this.showInstalliOS = true
      window.localStorage.setItem('TimerPwa_ShownInstallBanner', true)
    } else {
      this.showInstalliOS = false
    }
    this.$eventBus.$on('checkHoursExceeding', () => {
      this.checkHoursExceeding()
    })

    /* get running time if path not /stemp */
    if (this.$route.path !== '/stemp' && this.$cookie.get(process.env.VUE_APP_TOKEN)) {
      this.$store.dispatch('getRunningTimer').then((data) => {
        if (data) {
          this.checkHoursExceeding()
        }
      }).catch(() => {}) // logged by the global API error handler
    }
    /* Task Count Update on changing the task page changes */
    this.$eventBus.$on('updateTaskCount', () => this.getTasksCount())
  },
  methods: {
    /**
     * 4975 — follow a snackbar's deep link (project-chat notifications).
     *
     * Guards against navigating to the route we are already on: vue-router
     * rejects a duplicate navigation, and the patched Router.push in
     * router/index.js swallows the rejection, so the toast would just sit there
     * looking broken. Closing it is the honest outcome in that case.
     */
    goToSnackbarRoute () {
      const target = this.snackbarRoute
      this.snackbar = false
      this.snackbarRoute = null
      if (!target) return

      if (this.$route.fullPath !== target) {
        this.$router.push(target).catch(() => {})
      }
    },

    getShifts () {
      this.$api.execute('get', 'shifts/active')
        .then((response) => {
          this.shifts = this.$formatter.cloneVariable(response.data)
          this.shiftCalculations()
        })
    },
    shiftCalculations () {
      const shiftObj = this.shifts.find(x => x.id === Number(this.getTimerObj ? this.getTimerObj.shift_id : null))
      if (shiftObj && shiftObj.timeTo) {
        const hours = moment(shiftObj.timeTo, 'hh:mm').diff(moment(shiftObj.timeFrom, 'hh:mm'))
        const timeHour = moment.duration(this.time).hours()
        const timeMinute = moment.duration(this.time).minutes()
        const timeSecond = moment.duration(this.time).seconds()
        const shiftHour = moment.duration(hours).hours()
        const shiftMinute = moment.duration(hours).minutes()
        const shiftSecond = moment.duration(hours).seconds()
        this.shiftTime = { hour: shiftHour, minute: shiftMinute, second: shiftSecond }
        if (moment(`${shiftHour}:${shiftMinute}:${shiftSecond}`, 'HH:mm:ss').isSameOrBefore(moment(`${timeHour}:${timeMinute}:${timeSecond}`, 'HH:mm:ss'))) {
          this.shiftEndDialog = true
        }
      }
    },
    loadFeaturesAndSetPermissions () {
      this.$i18n.locale = window.localStorage.getItem(process.env.VUE_APP_LOCALE_STORAGE) ? window.localStorage.getItem(process.env.VUE_APP_LOCALE_STORAGE) : 'no'
      const authToken = this.$cookie.get(process.env.VUE_APP_TOKEN)
      const user = this.$cookie.get(process.env.VUE_APP_USER) ? JSON.parse(this.$cookie.get(process.env.VUE_APP_USER)) : {}
      const authDetails = { authToken, user }
      if (authToken) {
        hostAppApi.get(`${this.getHostRefApi}check_and_get_tenant_features?user_id=${this.userId}&is_pwa=1`, { headers: { language: this.$i18n.locale } })
          .then((response) => {
            if (response && response.data) {
              if (response.data.features) {
                window.localStorage.removeItem(process.env.VUE_APP_FEATURES_LIST)
                window.localStorage.setItem('UserRole', JSON.stringify(response.data.role))
                window.localStorage.setItem('Integrations', JSON.stringify(response.data.integrations ?? {}))
                // role-based PWA module access (consumed by the dashboard): the
                // tiles this user may show, and whether they're an admin (all tiles).
                // Only cache when a real user_id was queried — at boot/just after
                // login it can be 0, and the backend then returns the "all tiles"
                // fallback, which must not be cached as the user's allowed set.
                if (this.userId) {
                  window.localStorage.setItem('WelditPwa_pwaAllowedTiles', JSON.stringify(response.data.pwa_allowed_tiles ?? []))
                  window.localStorage.setItem('WelditPwa_pwaIsAdmin', response.data.pwa_is_admin ? '1' : '0')
                }
                const features = response.data.features
                if (features.timer.enabled) {
                  setTimeout(() => {
                    window.localStorage.setItem(process.env.VUE_APP_FEATURES_LIST, this.$formatter.encryptString(JSON.stringify(features)))
                  }, 0)
                } else {
                  this.$root.$emit('snackbar', { snackbar: true, color: 'success', text: 'message.common.timerFeatureDisabled' })
                  this.$store.dispatch('logout')
                  this.$router.push('/login').catch(() => {})
                }
              }
              if (response.data.permissions && response.data.role) {
                /* set user permission and roles  */
                var date = new Date()
                date.setDate(date.getDate() + 4)
                const obj = JSON.stringify({ permissions: response.data.permissions || {}, role: response.data.role || {} })
                if (obj) {
                  this.$cookie.set(process.env.VUE_APP_PERMISSIONS_AND_ROLES, this.$formatter.encryptString(obj), { expires: date })
                  this.$store.commit('setPermissions', JSON.parse(obj))
                }
              }
              // 4975: seed the project-chat notifier from this call.
              // It already runs on every launch and reload, so taking the unread
              // summary from here is what lets the notifier keep its own timer
              // switched off — no more repeated project-chat/unread requests.
              if (response.data.project_chat && this.pcnApplyPayload) {
                this.pcnApplyPayload(response.data.project_chat)
              }
            }
          })
        this.$store.commit('setAuth', authDetails)
      }
      /* set permission and roles in store-state variables */
      let permissionsAndRoles = this.$cookie.get(process.env.VUE_APP_PERMISSIONS_AND_ROLES)
      if (permissionsAndRoles) {
        permissionsAndRoles = JSON.parse(this.$formatter.decryptString(permissionsAndRoles))
        if (permissionsAndRoles) this.$store.commit('setPermissions', permissionsAndRoles)
      }
    },
    isIos () {
      const userAgent = window.navigator.userAgent.toLowerCase() || navigator.userAgent.toLowerCase() || navigator.vendor.toLowerCase() || navigator.platform.toLowerCase()
      return (/iphone|ipad|ipod/.test(userAgent)) || (/macintosh/.test(userAgent) && 'ontouchend' in document)
    },
    isInStandaloneModeIos () {
      return ('standalone' in window.navigator) && (window.navigator.standalone)
    },
    onScroll () {
      if (window.pageYOffset <= 0) this.showScrollToTop = false
      else this.showScrollToTop = true
    },
    scrollToTop () {
      goTo(0)
    },
    loadUpdateContent () {
      this.$store.dispatch('reloadNewContent')
    },
    checkHoursExceeding () {
      // var self = this
      // Notification.requestPermission().then(function (result) {
      //   if (result === 'granted') {
      //     if (window.localStorage.getItem('startedTimeOfTimer')) {
      //       const currentDate = moment(moment().format('YYYY-MM-DDTHH:mm:ss'), 'YYYY-MM-DDTHH:mm:ss')
      //       const startDate = moment(window.localStorage.getItem('startedTimeOfTimer'), 'DD.MM.YYYY HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss')
      //       const secondsCount = Math.abs(currentDate.diff(startDate, 'seconds'))
      //       const seconds = isNaN(secondsCount) ? 0 : secondsCount
      //       // const hours = Math.floor(seconds / 3600)
      //       // const minutes = Math.floor(seconds / 60)
      //       // if (hours >= 8 && 'serviceWorker' in navigator) {
      //       //   navigator.serviceWorker.getRegistration().then(function (reg) {
      //       //     var options = {
      //       //       body: self.$t('message.timer.hoursExceeding'),
      //       //       icon: require(`../public/img/${self.notificationImage}.png`)
      //       //     }
      //       //     if (reg) {
      //       //       reg.showNotification(self.notificationTitle, options)
      //       //     }
      //       //   })
      //       //   self.$store.state.common.notifiedCount = 1
      //       // }
      //     }
      //   }
      // })
    },
    getTasksCount () {
      hostAppApi.get(`${this.getHostRefApi}get_task_count?user_id=${this.userId}`)
        .then((response) => {
          if (response.data) {
            const taskCount = response.data.task_count || 0
            window.localStorage.setItem(process.env.VUE_APP_TASKS_COUNT, taskCount)
            try {
              this.$refs.headerLogo.$data.tasksCount = `${taskCount}`
            } catch (e) {}
          }
        })
        .catch(() => {}) // badge only; logged by the global API error handler
    },
    handleUserActivity () {
      this.$session.set('lastActivity', Date.now())
    }
  },
  beforeMount () {
    const apis = [api, hostAppApi]
    hostAppApi.interceptors.request.use((config) => {
      // 4975: name the socket this request comes from, so a broadcast the
      // server sends skips the sender's own connection (the POST response
      // already carries the result). Only while a socket is up.
      //
      // 5089: sent as the `socket_id` query parameter, NOT as the X-Socket-Id
      // header Laravel reads by default. Production CORS for the API is
      // answered by nginx with a fixed Access-Control-Allow-Headers list that
      // does not include it, and one disallowed header fails the preflight of
      // EVERY request the moment the socket connects. A query parameter needs
      // no allowance. Read by ProjectChatAPIController::senderSocketId().
      const socketId = this.$projectChatRt && this.$projectChatRt.socketId()
      config.params = {
        ...config.params,
        is_pwa: 1,
        user_id: this.userId,
        ...(socketId ? { socket_id: socketId } : {})
      }
      return config
    })
    apis.forEach(element => {
      element.interceptors.request.use((config) => {
        config.headers.language = this.$i18n.locale || 'en'
        return config
      })
      element.interceptors.response.use(
        (response) => {
          if (response && response.data && response.data.status && response.data.status !== 'success' && response.data.errorcode && response.data.errorcode !== 200) {
            if (response.data.errorcode === 499) {
              const text = this.$t('message.common.sharePoint')
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: text, isException: true })
              return Promise.reject(response)
            } else {
              const text = response.data.message
              this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(text), isException: true })
              return Promise.reject(response)
            }
          } else {
            return Promise.resolve(response)
          }
        },
        (error) => {
          // Opt-out for background requests whose failure is not worth a toast
          // (the chat unread badge, for one: it is decoration, and a 403 from a
          // project the user may not have chat access to must not put "Somthing
          // went wrong" on top of the page). The caller's own .catch() still
          // runs — this only suppresses the global snackbar. 401 stays handled
          // below, because a dead session has to log out whoever noticed it.
          const silenced = !!(error.config && error.config.silenceErrors)
          if (silenced && !(error.response && error.response.status === 401)) {
            return Promise.reject(error)
          }
          // No toast from here, whatever the status: every API error is logged
          // to the console for developers instead. The caller's own .catch()
          // still runs and can show its own message where one makes sense.
          // Only the 401 keeps behaviour, because a dead session has to log out.
          if (error.response) {
            const status = error.response.status
            const url = error.response.config && error.response.config.url ? error.response.config.url : '(unknown url)'
            let detail = error.response.data
            if (status === 404 && typeof detail === 'string') {
              // Laravel's 404 is an HTML page; keep only its text.
              detail = new DOMParser().parseFromString(detail, 'text/html').documentElement.textContent.trim()
            } else if (status === 422 && detail && typeof detail === 'object') {
              // Validation errors: the field messages, or the plain message.
              detail = detail.errors || detail.message || detail
            }
            console.warn('API error ' + status + ':', url, detail)
            if (status === 401) {
              // a 401 from the logout endpoint itself must not dispatch logout
              // again — that re-posts api/logout without a token and loops
              if (!url.endsWith('/logout')) {
                this.$store.dispatch('logout')
                this.$router.push('/login').catch(() => {})
              }
            }
          } else {
            const text = 'Somthing went wrong'
            console.warn('API error (no response):', text, error)
          }
          // else this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(exception), isException: true })
          // else {
          //   console.log(error.response)
          //   if (error.response.status === 499) {
          //     const text = this.$t('message.common.sharePoint')
          //     this.$root.$emit('snackbar', { snackbar: false, color: 'error', text, isException: true }) // Set false to stop "Share point credential issue" snackbar message in after refresh, it's not stop login failed message, both are different
          //   } else {
          //     const text = 'Somthink went wrong'
          //     this.$root.$emit('snackbar', { snackbar: true, color: 'error', text: JSON.stringify(text), isException: true })
          //   }
          // }
          return Promise.reject(error)
        }
      )
    })
  },
  watch: {
    '$i18n.locale' (val) {
      this.$eventBus.$emit('languageChanged', val)
    }
  },
  beforeDestroy () {
    this.$eventBus.$off('checkHoursExceeding')
    this.$eventBus.$off('updateTaskCount')
    this.$root.$off('popupDialog')
  },
  destroyed () {
    this.$root.$off('snackbar')
    this.$root.$off('timer')
    this.$root.$off('appTheme')
  }
}
</script>
<style lang="scss">
  @import './assets/css/app.scss';
  .dashboard_bg_color {
    background: linear-gradient(180deg, #578ebe 50%, #ffffff 50%);
  }
  /* full-viewport dashboard background (edge to edge, theme-aware). The class is
     toggled on <body> by the dashboard component so it covers the entire page
     including side margins, and switches when dark mode is toggled. */
  body.dashboard-body-bg,
  body.dashboard-body-bg #app,
  body.dashboard-body-bg .v-application,
  body.dashboard-body-bg .v-application--wrap,
  body.dashboard-body-bg .v-main,
  body.dashboard-body-bg .container--app { background: #f4f7fb !important; }
  body.dashboard-body-bg.dashboard-body-bg--dark,
  body.dashboard-body-bg.dashboard-body-bg--dark #app,
  body.dashboard-body-bg.dashboard-body-bg--dark .v-application,
  body.dashboard-body-bg.dashboard-body-bg--dark .v-application--wrap,
  body.dashboard-body-bg.dashboard-body-bg--dark .v-main,
  body.dashboard-body-bg.dashboard-body-bg--dark .container--app { background: #0b1019 !important; }
  /* styles for autocomplete */
  .v-autocomplete__content > .v-select-list > .v-list-item {
    min-height: 32px;
    margin-bottom: 4px;
  }
  .v-autocomplete__content > .v-select-list > .v-list-item > .v-list-item__content {
    padding: 0px 3px 2px !important;
    border-bottom: rgba(0,0,0,.12);
  }
  .v-autocomplete__content > .v-select-list > .v-list-item > .v-list-item__content > .v-list-item__title {
    white-space: normal;
  }
  /* added below code when css size issue occured after doing npm install */
  .row {
    margin: 0px;
  }
</style>
